import { CountryCode } from '../components/Countires';
import { RegionCode } from '../types';
import { TaxNumber } from '../types/taxNumber.types';

export const FormConfig = {
  EU: {
    code: RegionCode.EU,
    fields: {
      regions: {
        invitationValues: undefined,
      },
      taxNumber: {
        type: TaxNumber.VAT,
        defaultFieldValue: undefined,
        extractFieldValue: (vatNumber) => vatNumber.substring(2, vatNumber.Length),
        validatable: true,
      },
      countryCode: {
        defaultFieldValue: undefined,
      },
    },
  },
  US: {
    code: RegionCode.US,
    fields: {
      regions: {
        invitationValues: {
          EU: {
            code: RegionCode.EU,
            disabled: true,
          },
          US: {
            code: RegionCode.US,
            disabled: false,
          },
        },
        defaultValue: RegionCode.US,
      },
      taxNumber: {
        type: TaxNumber.EIN,
        extractFieldValue: (einNumber) => einNumber,
        validatable: false,
      },
      countryCode: {
        defaultFieldValue: CountryCode.US,
      },
    },
  },
  default: {
    code: undefined,
    fields: {
      regions: {
        values: {
          EU: {
            code: RegionCode.EU,
            disabled: false,
          },
          US: {
            code: RegionCode.US,
            disabled: false,
          },
        },
        defaultValue: RegionCode.EU,
      },
    },
  },
};
